import { normalizeProfileUser } from './profile';
import { GET, POST, PUT, DELETE } from "./api";
import { trackEvent } from "./analytics";

export const WELCOME_ONBOARDING_VIDEO_KEY = 'welcome-onboarding';

export const ReadMe = async () => {
    return normalizeProfileUser(await GET(`/me`, true));
}

export const UpdateMe = async (params) => {
    const result = await PUT(`/me`, params, true);
    if (result && !result?.error) trackEvent('PROFILE_UPDATE');
    return result;
}

export const RemoveMe = async () => {
    return await DELETE(`/me`, true);
}

export const UpdateMePassword = async (params) => {
    const result = await PUT(`/me/password`, params, true);
    if (result && !result?.error) trackEvent('PASSWORD_RESET');
    return result;
}

export const ReadOnboardingVideoProgress = async (videoKey = WELCOME_ONBOARDING_VIDEO_KEY) => {
    return await GET(`/me/onboarding-video-progress?videoKey=${encodeURIComponent(videoKey)}`, true);
}

export const UpdateOnboardingVideoProgress = async (params) => {
    return await POST(`/me/onboarding-video-progress`, params, true);
}
